<script lang="ts">
    import { _ } from "svelte-i18n"
    import { currentColorTheme } from "../../store"

    export let color: string = "default"
    let prefix = "theme-"

    if (localStorage.getItem("currentColorTheme")) {
        color = localStorage.getItem("currentColorTheme")
        document.body.classList.add(prefix + color)
    }

    const toggle = () => {
        document.body.classList.remove(prefix + color)

        color = color === "default" ? "dark" : "default"

        localStorage.setItem("currentColorTheme", color)

        document.body.classList.add(prefix + color)

        $currentColorTheme = color
    }
</script>

<div class="color-switcher-container">
    <div class="color-switcher" on:click="{toggle}" on:keypress>
        <div class="color-switch {prefix + color}"></div>
    </div>

    {$_("theme." + color)}
</div>
